<template>
  <div class="d-flex align-items-center phone-wrapper colg-forminput w-100">
    <div class="w-40">
      <label class="mb-0 fs-14 fw-500 font-mont color-344054">
        {{ label }} <span v-if="mandatory" class="color-red">*</span>
      </label>
    </div>

    <div class="w-60 d-flex align-items-center">
      <input
        ref="phoneInput"
        type="tel"
        class="form-control w-100"
        :placeholder="placeholder || 'Enter phone number'"
        :disabled="disabled"
        :class="{ 'border-error': error }"
      />
    </div>
  </div>
</template>

<script>
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";

export default {
  props: {
    value: String,
    label: String,
    placeholder: String,
    mandatory: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iti: null,
    };
  },
  mounted() {
    const input = this.$refs.phoneInput;

    this.iti = intlTelInput(input, {
      initialCountry: "in",
      nationalMode: false,
      separateDialCode: true, // ✅ Enables flag + code shown outside the input
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js",
    });

    if (this.value) {
      this.iti.setNumber(this.value);
    }

    input.addEventListener("input", this.emitFormattedPhone);
    input.addEventListener("countrychange", this.emitFormattedPhone);
  },

  watch: {
    value(newVal) {
      if (this.iti && newVal !== this.iti.getNumber()) {
        this.iti.setNumber(newVal);
      }
    },
  },
  methods: {
    emitFormattedPhone() {
      const phoneInput = this.$refs.phoneInput;

      const number = this.iti?.getNumber() || phoneInput.value;
      const countryCode = `+${this.iti?.getSelectedCountryData().dialCode}`;

      this.$emit("input", number); // full international number
      this.$emit("country-code", countryCode); // emit just the dial code
    },
  },
};
</script>

<style scoped>
.border-error {
  border: 1px solid red !important;
}
.phone-wrapper .w-40 {
  min-width: 160px;
}
.colg-forminput .form-control {
  padding: 10px 14px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
  width: 60%;
}
.colg-forminput .form-control:focus {
  box-shadow: none;
  color: #333333;
  background-color: #fff;
  outline: 0;
}
.colg-forminput .form-control:disabled,
.form-control[readonly] {
  background: #f7f7f7;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border: unset;
}
</style>
